export enum STYLE_TYPE {
  default,
  big,
}

export enum LABEL_TYPE {
  default,
  long,
}

export interface Props {
  className?: string;
  labelType?: LABEL_TYPE;
  styleType?: STYLE_TYPE;
}

export enum INK_CATEGORY_URL {
  de = '/computing-software/peripherie/tinte-toner',
  fr = '/fr/computing-logiciels/peripheriques/encre-toner',
}

export enum PRINTERS_CATEGORY_URL {
  de = '/computing-software/peripherie/drucker',
  fr = '/computing-software/peripherie/drucker',
}

